import { render, staticRenderFns } from "./CustomLabelPopup.vue?vue&type=template&id=2a5c9dfc&"
import script from "./CustomLabelPopup.vue?vue&type=script&lang=js&"
export * from "./CustomLabelPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports